module.exports = __webpack_public_path__ + "static/media/35.3db30fc.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/35.wav
// module id = aHtN
// module chunks = 0